export default "__VITE_ASSET__D06dY5ft__"